<div class="chat-container">
  <div class="messages-container">
    <app-message *ngFor="let message of messages" [message]="message"></app-message>
  </div>

  <div class="footer">
    <div class="input-wrapper">
      <textarea [(ngModel)]="text" [placeholder]="'Nachricht eingeben'" (keydown.enter)="handleSend(); $event.preventDefault()"></textarea>
      <button type="submit" (click)="handleSend()" [disabled]="text.length === 0"><i class="fas fa-circle-up" [class.primary-color]="text.length > 0"></i></button>
    </div>
  </div>
</div>